import { useTranslation } from "react-i18next";
import PlayoffContent from "./playoff";
import InfoCircle from "./infoCircle";
import { formatNumber } from "utils/utils";
import SeasonContent from "./season";

import { useRef, useEffect } from "react";
import Winners from "./winners";

const CardContent = ({ leagueData, userRoundData }) => {
  /*   const swiperElRef = useRef(null);

  useEffect(() => {
    const swiperContainer = swiperElRef.current;
    const params = {
      navigation: true,
      centeredSlides: true,

      autoHeight: true,
      spaceBetween: 50,
      slidesPerView: 1,
      initialSlide: 0,
      speed: 400,
    };

    Object.assign(swiperContainer, params);
    swiperContainer.initialize();
  }, []); */

  const { gameType, eliminatedCount, userCount } = leagueData;
  let eliminatedPercentage = (eliminatedCount / userCount) * 100;
  return (
    <div className="w-full h-full flex justify-center items-center">
      {/*       <swiper-container
        ref={swiperElRef}
        init="false"
        style={{
          "--swiper-navigation-color": "#fff",
          "--swiper-navigation-size": "24px",
        }}
      > */}
      {leagueData?.settled && leagueData?.winners?.length ? (
        // <swiper-slide>
        <Winners tournament={leagueData} />
      ) : // </swiper-slide>
      gameType === 0 ? (
        <SeasonContent leagueData={leagueData} userRoundData={userRoundData} />
      ) : (
        <PlayoffContent leagueData={leagueData} userRoundData={userRoundData} />
      )}
      {/* </swiper-container> */}
    </div>
  );
};

export default CardContent;
